var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "matrix(-1 0 0 1 16 0)",
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 12.6667C9.4891 12.667 9.64006 12.6127 9.76 12.5133C9.89634 12.4003 9.9821 12.2377 9.99836 12.0613C10.0146 11.885 9.96004 11.7094 9.84667 11.5733L6.86 8L9.74 4.42C9.85185 4.28227 9.90418 4.10564 9.88541 3.92922C9.86664 3.75279 9.77832 3.59112 9.64 3.48C9.50056 3.35731 9.31625 3.29835 9.13148 3.31734C8.94672 3.33632 8.77825 3.43152 8.66667 3.58L5.44667 7.58C5.24445 7.826 5.24445 8.18067 5.44667 8.42667L8.78 12.4267C8.91564 12.5903 9.12118 12.6794 9.33333 12.6667Z",
    fill: "#919EAB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnBack);
export default __webpack_public_path__ + "static/media/btn-back.9a97b92dfc13a175ef79993e8f3e4b60.svg";
export { ForwardRef as ReactComponent };